import { useEffect } from 'react';
import moment from 'moment';
import useAuthStore from '../store/authStore';
import useHomeStore from '../store/homeStore';
import { DatePFormat } from '../utils/StaticVariable';
import { useGetCurrentUserQuery } from './useGetCurrentUserQuery';

export const useSilentAuth = () => {
  const setUser = useAuthStore((state) => state.setUser);
  const clearAuth = useAuthStore((state) => state.clearAuth);
  const setShowSubscriptionExpiredModal = useHomeStore(
    (state) => state.setShowSubscriptionExpiredModal
  );
  const { isSuccess, data: user, isError, error } = useGetCurrentUserQuery();

  useEffect(() => {
    if (!isSuccess || !user) return;

    if (user?.authenticated) {
      sessionStorage.setItem('wasSignedInBefore', '1');
    }
    setUser(user);
    const _paq = (window._paq = window._paq || []);
    _paq.push(['setUserId', user.userName]);
    _paq.push(['trackPageView']);
    _paq.push(['enableHeartBeatTimer']);
    const now = new Date();
    const threeMonthsFromNow = new Date();
    threeMonthsFromNow.setMonth(threeMonthsFromNow.getMonth() + 3);

    if (!user?.subscriptionExpiryDate) return;

    const subscriptionExpiryDateObj = new Date(user.subscriptionExpiryDate);
    const formattedSubscriptionDate = moment(subscriptionExpiryDateObj).format(
      DatePFormat
    );

    if (now > subscriptionExpiryDateObj) {
      setShowSubscriptionExpiredModal({
        header: 'Subscription expired',
        message: `Your subscription to ${user.subscriptionType} expired on ${formattedSubscriptionDate}.
                 Please contact customer care mike@dhigroup.com to renew your subscription`,
        status: true,
      });
    } else if (subscriptionExpiryDateObj <= threeMonthsFromNow) {
      setShowSubscriptionExpiredModal({
        header: 'Subscription expiry',
        message: `Your subscription to ${user.subscriptionType} expires on ${formattedSubscriptionDate}.
                 Please contact customer care mike@dhigroup.com to extend your subscription`,
        status: true,
      });
    }
  }, [isSuccess, user, setUser, setShowSubscriptionExpiredModal]);

  useEffect(() => {
    if (isError) {
      clearAuth();
    }
  }, [isError, error, clearAuth]);

  return { user, error, isSuccess, isError };
};
